import { StyleSheet, View } from 'react-native';

import { centeredRowContainerStyles } from 'components/ui/centered-row-container';
import { Skeleton } from 'components/ui/skeleton';
import { primitive, spacing } from 'styles/constants';
import { WEB_SMALL_MAX_WIDTH } from 'utils/constants';

import { LoyaltyHistoryHeaderSkeleton } from './loyalty-history-header-skeleton';
import { LoyaltyTransactionCardSkeleton } from './loyalty-transaction-card-skeleton';

export const LoyaltyHistorySkeletonLoader = () => {
  return (
    <View style={styles.wrapper}>
      <View style={styles.container}>
        <LoyaltyHistoryHeaderSkeleton />
        <View style={styles.middleContainer}>
          <Skeleton shape="circle" style={{ width: '35%' }} />
        </View>

        <View style={styles.middleBottom}>
          <Skeleton shape="rectangle" style={{ height: 32, width: '70%' }} />
          <Skeleton shape="rectangle" style={{ height: 12, width: '80%' }} />
          <Skeleton shape="rectangle" style={{ height: 12, width: '60%', marginTop: 0 }} />
        </View>

        <LoyaltyTransactionCardSkeleton />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    alignSelf: 'center',
    paddingHorizontal: spacing.$4,
    ...centeredRowContainerStyles.content,
    maxWidth: WEB_SMALL_MAX_WIDTH,
  },
  container: {
    marginVertical: spacing.$4,
  },
  middleContainer: { alignItems: 'center', paddingVertical: spacing.$8 },
  separator: {
    height: 1,
    borderBottomWidth: 1,
    borderColor: primitive.$blackOpacity30,
    marginBottom: spacing.$2,
  },
  middleBottom: {
    alignItems: 'center',
  },
});
